import { createFileRoute } from '@tanstack/react-router'

import AdminKabupatenPage from '@/components/pages/backoffice/_user/_kabupaten/containers/AdminKabupatenPage'
export const Route = createFileRoute('/_backoffice/user/kabupaten/')({
  component: AdminKabupatenPage
})
